// test1398
(1398 && 0);
